import { useState, useCallback } from 'react';
import { sendMessage } from '@/services/api';

export function useChat() {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [leadSaved, setLeadSaved] = useState(false);
  const [leadId, setLeadId] = useState(null);
  const [error, setError] = useState(null);

  const send = useCallback(async (text) => {
    if (!text.trim() || isLoading) return;

    const userMessage = { role: 'user', parts: [{ text }] };
    const nextMessages = [...messages, userMessage];
    setMessages(nextMessages);
    setIsLoading(true);
    setError(null);

    try {
      const { reply, leadSaved: saved, leadId: id } = await sendMessage(nextMessages);
      setMessages(prev => [...prev, { role: 'model', parts: [{ text: reply }] }]);
      if (saved) {
        setLeadSaved(true);
        setLeadId(id);
      }
    } catch (err) {
      setError('Failed to send message. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [messages, isLoading]);

  const greet = useCallback(async () => {
    if (messages.length > 0 || isLoading) return;
    setIsLoading(true);
    setError(null);
    try {
      const { reply } = await sendMessage([{ role: 'user', parts: [{ text: '__GREET__' }] }]);
      setMessages([{ role: 'model', parts: [{ text: reply }] }]);
    } catch {
      setError('Failed to connect. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [messages, isLoading]);

  const reset = useCallback(() => {
    setMessages([]);
    setIsLoading(false);
    setLeadSaved(false);
    setLeadId(null);
    setError(null);
  }, []);

  return { messages, isLoading, leadSaved, leadId, error, send, greet, reset };
}
